import { Component, OnInit, Optional } from '@angular/core';
import { ControlContainer, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { ProcessShellService } from '../services/process-shell.service';
import { TransfersResultPageHelper, TransfersResultPageState } from './transfers-result-page.helper';
import { TransfersResultPageService } from './services/transfers-result-page.service';
import { BeneficiariesService } from 'src/app/transfers/beneficiaries-service/beneficiaries.service';


@Component({
  selector: 'app-transfers-result-page',
  templateUrl: './transfers-result-page.component.html',
  styleUrls: ['./transfers-result-page.component.scss'],
  providers: [
    TransfersResultPageHelper
  ]
})
export class TransfersResultPageComponent extends BaseFpxFormComponent<TransfersResultPageHelper, TransfersResultPageState> {

  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    public transfersResultPageService:TransfersResultPageService,
    public beneficiariesService: BeneficiariesService,
    private _router: Router,
    public formHelper: TransfersResultPageHelper,
    public _processShellService: ProcessShellService

  ) {
    super(formBuilder, _router, controlContainer, formHelper);
  }
  

}
